import { render } from "./contentPreferred.vue?vue&type=template&id=51b75362&scoped=true"
import script from "./contentPreferred.vue?vue&type=script&lang=js"
export * from "./contentPreferred.vue?vue&type=script&lang=js"

import "./contentPreferred.vue?vue&type=style&index=0&id=51b75362&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b75362"]])

export default __exports__